<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton title :row="20" :loading="loadingPage">
      <div v-for="(type,index) in typeList" :key="index" class="typeRect">
        <div v-if="!type.isHide" class="title">
          {{ type.name }}
          <span v-if="type.type==='Coach'">教练</span>
          <span v-if="type.type==='DivePlace'">潜点</span>
          <span v-if="type.type==='Course'">行程/课程</span>
        </div>
        <div v-if="!type.isHide && type.data" class="LineRectImg">

          <div class="LeftRect">
            <van-image
              width="4em"
              height="4em"
              fit="cover"
              :src="type.icon?type.icon:'/img/defaultIcon.jpg'"
            />
          </div>
          <div class="CenterRect">
            <van-rate v-model="type.data.score" size="1.5em" :color="GetDiveMainBack()" readonly />
          </div>
          <div class="RigthRect" :style="'color:'+GetDiveMainBack()">
            {{ getScoreText(type.data.score) }}
          </div>
        </div>
        <template v-if="!type.isHide && type.data">
          <div v-for="(config,indexConfig) in type.configList" :key="indexConfig" class="LineRect">
            <template v-if="config.commentType==='SOCRE'">
              <div class="LeftRect">
                {{ config.name }}
              </div>
              <div class="CenterRect">
                <van-rate v-model="getLocationData( type.type, config.location).score" size="1.5em" :color="GetDiveMainBack()" readonly />
                <div class="tagButtonRects">
                  <div v-for="(tag,tagIndex) in getLocationData(type.type, config.location).tag" :key="tagIndex" class="tagButton">{{ tag }}</div>
                  <div v-for="(tag,tagIndex) in getLocationData( type.type, config.location).tagBadly" :key="'a'+tagIndex" class="tagButton">{{ tag }}</div>
                </div>
              </div>
            </template>
            <template v-if="config.commentType==='YESNO'">
              <div class="LeftRect">
                {{ config.name }}
              </div>
              <div class="CenterRect">
                <div class="aboutBoolean">{{ config.about }}</div>
                {{ getLocationData( type.type, config.location).score===5?'是':'否' }}
              </div>
            </template>
          </div>
        </template>
        <div v-if="!type.isHide && type.data" class="LineRect">
          <div class="LeftRect">
            评语
          </div>
          <div class="CenterRect">
            {{ type.data.about }}<br>
            <van-image
              v-for="(img,imgIndex) in type.data.res"
              :key="imgIndex"
              class="imgIndex"
              width="4em"
              height="4em"
              fit="cover"
              lazy-load
              :src="img"
              radius="0.3em"
              @click="showPreview(type.data.res)"
            />
          </div>

        </div>
      </div>
      <!--

          <div class="LineRect">
            <div class="LeftRect">
              评语
            </div>
            <div class="CenterRect">
              <van-field
                v-model="postData[index].about"
                rows="3"
                autosize
                type="textarea"
                placeholder="请输入点评意见,这对我们很重要!"
                style="background-color:#f5f5f5"
              />
              <van-uploader
                v-model="postData[index].fileList"
                class="imageUpload"
                multiple
                :max-count="20"
                :after-read="afterRead"
                preview-size="60px"
              />
            </div>
          </div>
        </template>
      </div> -->
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { getDiveCommentConfigList } from '@/utils/baseData'
import { Button, Image, Rate, Field, Uploader, Skeleton, ImagePreview, Switch } from 'vant'
import TopBar from '@/components/TopBar'
import { getScoreText, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Rate.name]: Rate,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Skeleton.name]: Skeleton,
    [ImagePreview.name]: ImagePreview,
    [Switch.name]: Switch,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '评论行程',
      backurl: '/dive',
      studentId: undefined,
      loadingPage: true,
      buttonLoading: false,
      configList: [],
      typeList: [],
      data: []
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.studentId = this.$route.params.id
    console.log('this.studentId', this.studentId)
    getDiveCommentConfigList((data) => {
      this.configList = data
      this.init(() => {
        this.initStudentComment(() => {
          this.typeList.forEach(item => {
            item.configList = this.configList.filter(el => el.type === item.type)
            var dataList = this.data.filter(el => el.type === item.type)
            if (dataList.length > 0) {
              item.data = dataList[0]
            } else {
              item.data = {}
            }
          })
        })
      })
    })
  },
  methods: {
    getScoreText,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    showPreview(imgs) {
      ImagePreview(imgs)
    },
    getLocationData(type, location) {
      var listType = this.data.filter(el => el.type === type)
      if (listType.length <= 0) {
        return {}
      }
      var item = listType[0].baseScore.filter(el => el.location === location)
      if (item.length > 0) {
        return item[0]
      } else {
        return {}
      }
    },
    initStudentComment(callback) {
      request({
        url: '/DiveData/getDiveCommentByStudentId',
        method: 'post',
        params: { id: this.studentId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.loadingPage = false
        if (callback) {
          callback()
        }
      })
    },
    init(callback) {
      request({
        url: '/DiveData/getStudentCommentTypleList',
        method: 'post',
        data: { studentId: this.studentId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.typeList = response.data.list
        if (callback) {
          callback()
        }
      })
    }
  }
}
</script>
<style scoped>
.typeRect
{
    background-color: #fff;
    padding: 0 1em;
    margin-bottom: 0.5em;
}
.typeRect .title{
    font-weight: 700;
    padding: 1em 0;
    position: relative;
    border-bottom: 1px solid #f5f5f5;

}
.typeRect .title .moreButton
{
    position: absolute;
    right: 0em;
    top: 1em;
    font-weight: normal;
    font-size: 0.8em;
    color: #999;
    line-height: 2em;
}

.LineRectImg{
    position: relative;
    padding: 1em 0;
    border-bottom: 1px solid #f5f5f5;
}
.LineRectImg .LeftRect{
    position: absolute;
    left: 0em;
}
.LineRectImg .CenterRect{
    margin-left: 5em;
    padding: 1.1em 0;
}
.LineRectImg .RigthRect{
    position: absolute;
    right: 0em;
    top: 1em;
    line-height: 4.5em;
    font-weight: 700;
    text-align: right;
    font-size: 0.9em;
}

.LineRect{
    position: relative;
    padding: 0.5em 0;
}
.LineRect .LeftRect{
    position: absolute;
    left: 0em;
    text-align: center;
    width: 4em;
    font-weight: 700;
    font-size: 0.9em;
    line-height: 2em;
}
.LineRect .CenterRect{
    margin-left: 5em;
}
.LineRect .RigthRect{
    position: absolute;
    right: 0em;
    top: 0.5em;
    font-weight: 700;
    text-align: right;
    font-size: 0.9em;
    line-height: 2em;
}
.tagButtonRects{
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5em;
}
.tagButtonRects .tagButton{
    margin-right: 0.5em;
    margin-bottom: 0.5em;
    border-radius: 0.4em;
    border: 2px solid #e2e2e2;
    background-color: #E2E2E2;

    color: #707070;
    font-size: 0.7em;
    padding: 0.25em 0.5em;
}
.emptyRect{
    height: 3em;
}
.buttonRect
{
    background-color: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    border-top: 1px solid #f5f5f5;
    padding: 1em 1em 0 1em;
}
.imageUpload{
  margin-top: 0.5em;
}
.imgIndex{
    margin:0.5em 0.5em 0 0;
    overflow: hidden;
}
.aboutBoolean{
  color:#999;
  font-size: 0.8em;
}
</style>
